import { api } from './apiClient';
import type { AuthResult, User } from '@/types/auth';

export interface RedeemResult {
  ok: boolean;
  codeId: string;
  userAccessPersisted: boolean;
  token: string;
}

export const authApi = {
  register(input: { email: string; password: string; displayName?: string }): Promise<AuthResult> {
    return api<AuthResult>('/api/auth/register', { method: 'POST', body: input });
  },
  login(input: { email: string; password: string }): Promise<AuthResult> {
    return api<AuthResult>('/api/auth/login', { method: 'POST', body: input });
  },
  google(credential: string): Promise<AuthResult> {
    return api<AuthResult>('/api/auth/google', { method: 'POST', body: { credential } });
  },
  guest(input: { localId: string; displayName?: string }): Promise<AuthResult> {
    return api<AuthResult>('/api/auth/guest', { method: 'POST', body: input });
  },
  me(): Promise<{ user: User }> {
    return api<{ user: User }>('/api/auth/me', { auth: true });
  },
  redeemAccessCode(code: string): Promise<RedeemResult> {
    return api<RedeemResult>('/api/access-codes/redeem', { method: 'POST', body: { code }, auth: true });
  },
};
